// removed by extract-text-webpack-plugin
module.exports = {"historyItem":"_2CY_","time":"_2YfU"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cases/CasesViewModal/CasesViewModal.scss
// module id = d9ob
// module chunks = 0